import styled, { css } from 'styled-components';
import Icon, { ICON_SIZES } from '@anwb/icon';
import { pxToRem } from '@anwb/style-utilities';
import Typography from '@anwb/typography';
const PRICE_MARGIN_TOP_FOR_ALIGNMENT = 1;
const SUBTITLE_MARGIN_TOP_FOR_ALIGNMENT = 3;
const SUBTITLE_MAX_WIDTH = '40%';
/**
 * Accordion container
 */
export const accordionContainerStyles = ({ theme, $isResponsive, }) => css `
	display: flex;
	flex-direction: column;
	width: 100%;
	border-bottom: ${theme.borderWidth['2']}px solid ${theme.colors.light.divider};

	${$isResponsive &&
    css `
		${StyledAccordionTriggerContent} {
			@media (min-width: ${pxToRem(theme.viewportBreakpoint.sm)}) {
				flex-direction: row;
				justify-content: space-between;
			}
		}
	`}
`;
export const StyledAccordion = styled.div `
	${accordionContainerStyles}
`;
/**
 * Accordion header
 */
export const accordionHeaderStyles = ({ theme }) => css `
	margin: 0;
	max-width: 100%;
	border-top: ${theme.borderWidth['2']}px solid ${theme.colors.light.divider};
	color: ${theme.colors.highlight.textInteractive};
`;
export const StyledAccordionHeader = styled.h3 `
	${accordionHeaderStyles}
`;
/**
 * Accordion trigger
 */
export const accordionTriggerStyles = ({ theme, $hasIcon, }) => css `
	display: flex;
	flex-direction: row;
	gap: ${pxToRem(theme.spacing['200'])};
	padding: ${pxToRem(theme.spacing['200'])};
	width: 100%;
	border: none;
	background-color: transparent;
	cursor: pointer;
	color: ${theme.colors.base.textLabel};

	${$hasIcon &&
    css `
		padding-left: 0;
	`}

	&:focus,
	&:hover {
		color: ${theme.colors.highlight.textInteractive};
	}

	// Core UI overrides
	&&& {
		border-radius: 0;
		text-align: left;
	}
`;
export const StyledAccordionTrigger = styled.button `
	${accordionTriggerStyles}
`;
export const accordionChevronStyles = ({ theme }) => css `
	flex: none;
	margin-top: ${pxToRem(theme.spacing['50'])};
	height: ${pxToRem(ICON_SIZES.md)};
	color: ${theme.colors.highlight.textInteractive};

	[aria-expanded='true'] & {
		transform: rotate(180deg);
	}
`;
export const StyledAccordionChevron = styled(Icon).attrs({
    variant: 'chevron-down',
    type: 'ui',
    size: 'md',
}) `
	${accordionChevronStyles}
`;
/**
 * Accordion trigger content
 */
export const accordionTriggerContentStyles = ({ theme }) => css `
	display: flex;
	flex-direction: column;
	width: 100%;
	overflow: hidden;

	@media (min-width: ${pxToRem(theme.viewportBreakpoint.sm)}) {
		flex-direction: column;
		gap: ${pxToRem(theme.spacing['200'])};
	}
`;
export const StyledAccordionTriggerContent = styled.div `
	${accordionTriggerContentStyles}
`;
/**
 * Accordion content
 */
export const accordionContentStyles = ({ theme }) => css `
	padding: 0 ${pxToRem(theme.spacing['200'])};
`;
export const StyledAccordionContent = styled.div `
	${accordionContentStyles}
`;
/**
 * Accordion text
 */
export const accordionBodyStyles = ({ theme }) => css `
	margin: 0 0 ${pxToRem(theme.spacing['300'])} 0;
	padding: 0;

	@media (min-width: ${pxToRem(theme.viewportBreakpoint.md)}) {
		margin-bottom: ${pxToRem(theme.spacing['400'])};
	}
`;
export const StyledAccordionBody = styled(Typography).attrs({
    variant: 'body-text',
    tagName: 'p',
}) `
	${accordionBodyStyles}
`;
/**
 * Accordion title
 */
export const accordionTitleStyles = ({ theme }) => css `
	color: ${theme.colors.highlight.textInteractive};
`;
export const StyledAccordionTitle = styled(Typography).attrs({
    variant: 'label-title',
    tagName: 'span',
}) `
	${accordionTitleStyles}
`;
/**
 * Accordion icon
 */
export const accordionIconStyles = ({ theme }) => css `
	flex: none;
	align-self: flex-start;
	margin-top: ${pxToRem(theme.spacing['50'])};
	height: ${pxToRem(ICON_SIZES.md)};
	color: currentColor;
`;
export const StyledAccordionIcon = styled(Icon) `
	${accordionIconStyles}
`;
/**
 * Accordion subtitle
 */
export const accordionSubtitleStyles = ({ theme }) => css `
	@media (min-width: ${pxToRem(theme.viewportBreakpoint.sm)}) {
		margin-top: ${pxToRem(SUBTITLE_MARGIN_TOP_FOR_ALIGNMENT)};
		max-width: ${SUBTITLE_MAX_WIDTH};
		width: auto;
	}
`;
export const StyledAccordionSubtitle = styled(Typography).attrs({
    variant: 'support-text',
    tagName: 'span',
}) `
	${accordionSubtitleStyles}
`;
/**
 * Accordion price
 */
export const accordionPriceStyles = ({ theme }) => css `
	@media (min-width: ${pxToRem(theme.viewportBreakpoint.sm)}) {
		margin-top: ${pxToRem(PRICE_MARGIN_TOP_FOR_ALIGNMENT)};
		white-space: nowrap;
	}
`;
export const StyledAccordionPrice = styled(Typography).attrs({
    variant: 'price-text-sm',
    tagName: 'span',
}) `
	${accordionPriceStyles}
`;
//# sourceMappingURL=accordion.styled.js.map